export interface DepartmentConfig {
  id: string;
  name: string;
  description: string;
  agentId: string;
  accentColor: string;
  gradientFrom: string;
  gradientTo: string;
  processAreas: string[];
  icon: string;
}

export const departments: DepartmentConfig[] = [
  {
    id: 'general',
    name: 'Data & Analytics',
    description: 'For data leaders whose sensitive datasets are locked out of AI',
    agentId: 'agent_1301knjv57a6er39becrx83xjmgw',
    accentColor: 'blue',
    gradientFrom: '#1e40af',
    gradientTo: '#7c3aed',
    processAreas: ['AI Readiness', 'Data Privacy Maturity', 'Collaboration Capability', 'Data Monetization', 'Tool Integration'],
    icon: 'BarChart3',
  },
  {
    id: 'compliance',
    name: 'Compliance & Risk',
    description: 'For compliance and legal teams navigating AI under CCPA, HIPAA, or GDPR',
    agentId: 'agent_1301knjv57a6er39becrx83xjmgw',
    accentColor: 'emerald',
    gradientFrom: '#065f46',
    gradientTo: '#1e40af',
    processAreas: ['Compliance Posture', 'Data Governance', 'Risk Management', 'Regulatory Readiness', 'Audit Controls'],
    icon: 'ShieldCheck',
  },
  {
    id: 'enterprise',
    name: 'Enterprise Technology',
    description: 'For CTOs and architects building secure AI infrastructure on sensitive data',
    agentId: 'agent_1301knjv57a6er39becrx83xjmgw',
    accentColor: 'teal',
    gradientFrom: '#134e4a',
    gradientTo: '#1e3a5f',
    processAreas: ['Infrastructure Security', 'AI Pipeline Maturity', 'Partner Data Sharing', 'Compute Efficiency', 'Key Management'],
    icon: 'Server',
  },
];

export function getDepartment(id: string): DepartmentConfig {
  return departments.find((d) => d.id === id) || departments[0];
}
